import React from "react";
import styled from "styled-components";

const TextWrapper = styled.div`
  transition: filter 0.3s ease-out;
  position: relative;
  padding: ${props => (props.primary ? "0px 0px 75px 0px" : "5px")};
  margin: 0;
  height: 150px;
  max-height: 200px;
  z-index: 1;
  @media only screen and (min-height: 630px) {
    height: 200px;
  }
  background: ${({ primary, theme}) => (primary ? theme.colors.accent : theme.colors.accent)};
`;

const TextArea = styled.textarea`
  background: ${({ primary, theme}) => (primary ? theme.colors.accent : theme.colors.blue)};
  border: none;
  resize: none;
  outline: none;
  border-radius: 0;
  width: 100%;
  height: 100%;
  color: ${({ primary, theme}) => (primary ? theme.colors.primary : theme.colors.accent)};
  opacity: 1;
  -webkit-text-fill-color: ${({ primary, theme}) => (primary ? theme.colors.primary : theme.colors.accent)};
  padding: 20px;
  font-size: 18px;
  font-family: "Trebuchet MS", "Lucida Grande", "Lucida Sans Unicode",
    "Lucida Sans", Tahoma, sans-serif;
  caret-color: ${({ primary, theme}) => (primary ? theme.colors.primary : theme.colors.accent)};
  &::selection {
    background: rgb(82, 155, 224);
  }
`;

const TranslationTextInput = props => {
  return (
    <TextWrapper
      blur={props.blur}
      primary={props.primary}
      onChange={() =>
        props.primary ? props.action(this[props.nodeRef].value) : null}
    >
      {props.children}
      <TextArea
        placeholder={props.placeholder}
        primary={props.primary}
        lang={props.lang}
        innerRef={n => (this[props.nodeRef] = n)}
        value={props.value}
      />
    </TextWrapper>
  );
};

export default TranslationTextInput;



// WEBPACK FOOTER //
// ./src/components/TranslationTextInput.js